import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class TableSortIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="12" viewBox="0 0 6 12" width="6" xmlns="http://www.w3.org/2000/svg"><path d="M.301 7h5.398a.301.301 0 0 1 .253.464l-2.699 4.198a.301.301 0 0 1-.506 0l-2.7-4.198A.301.301 0 0 1 .302 7zm0-2.2a.301.301 0 0 1-.253-.463L2.747.138a.3.3 0 0 1 .506 0l2.7 4.199a.301.301 0 0 1-.254.463H.301z" fillRule="evenodd"/></svg>
        )
    }
}

export default withCssClassName(TableSortIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/table-sort-icon.js